import React from 'react';
import {
  ContainerInfos,
  ContainerCardBoletos,
  HeaderCardBoleto,
  BodyCardBoleto,
  ButtonsContainer,
  ProcessìngPixButtonContainer,
} from './styledCardBoleto';
import { Divider } from '@material-ui/core';
import BotaoCopiarCodBoleto from './BotaoCopiarCodBoleto';
import BotaoVisualizarBoleto from './BotaoVisualizarBoleto';
import formatCurrent from '../../../../Utils/formatCurrent';
import formatDate from '../../../../Utils/formatDate';
import { ReactComponent as BoletoIcone } from '../../../../assets/novosicones/Financeiro/boleto-simples.svg';
import { ReactComponent as BoletoAgrupado } from '../../../../assets/novosicones/Financeiro/CartaoCredito/groupedBill.svg';
import BotaoEnviarBoletoEmail from './BotaoEnviarBoletoEmail';

import * as functionsCardBoletos from './functionsCardBoletos';
import BotaoPix from './BotaoPix';

import BotaoCartao from './BotaoCartao';
import TooltipStandard from '../../../TooltipStandard';

import { ReactComponent as HelpIcon } from '../../../../assets/novosicones/help_outline.svg';

const CardBoletos = ({
  parcelas,
  tema,
  geracaoBoleto,
  contratoSelecionado,
}) => {
  const arrayParcelas =
    functionsCardBoletos?.handleArrayParcelasValue(parcelas);

  const boletoAtrasado = functionsCardBoletos?.isBoletoAtrasado(arrayParcelas);

  const textoProcessando =
    functionsCardBoletos?.handleProcessingMessage(arrayParcelas);

  const processandoPix = functionsCardBoletos.isProcessandoPix(arrayParcelas);

  const isShowPix = functionsCardBoletos.isShowPix(
    contratoSelecionado,
    arrayParcelas
  );
  const isShowCard = functionsCardBoletos.isShowCard(arrayParcelas);

  const isShowPaymentMethods = functionsCardBoletos.isShowPaymentMethods(
    geracaoBoleto,
    isShowPix,
    isShowCard
  );

  return (
    <ContainerCardBoletos
      atrasada={boletoAtrasado}
      pagamentoProcessando={!!textoProcessando}
      tema={tema}
    >
      <ContainerInfos>
        <HeaderCardBoleto atrasada={boletoAtrasado} tema={tema}>
          <div className='infosHeaderCardBoleto'>
            <div className='description-container'>
              <div className='boletoIcone'>
                {arrayParcelas.length > 1 ? (
                  <BoletoAgrupado />
                ) : (
                  <BoletoIcone />
                )}
              </div>
              <div>
                <span>Descrição do boleto:</span>
                <span className='description'>
                  {arrayParcelas.length > 1
                    ? 'Parcelas agrupadas'
                    : 'Parcela simples'}
                </span>
              </div>
            </div>
            <div>
              <span>Valor do boleto:</span>
              <span>
                {formatCurrent(
                  functionsCardBoletos.handleValueBoleto(arrayParcelas)
                )}
              </span>
            </div>
            <div>
              {textoProcessando ? (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span className='processandoPagamento'>
                    {textoProcessando}
                  </span>

                  {processandoPix && (
                    <TooltipStandard
                      title={functionsCardBoletos.TEXT_PIX_TOOLTIP}
                    >
                      <span style={{ marginLeft: 8 }}>
                        <HelpIcon />
                      </span>
                    </TooltipStandard>
                  )}
                </div>
              ) : (
                <>
                  <span>Vencimento do boleto:</span>
                  <span className='dataVencimento'>
                    {formatDate(arrayParcelas[0]?.parcela?.dtVencBoleto)}
                  </span>
                </>
              )}
            </div>
          </div>
        </HeaderCardBoleto>

        <BodyCardBoleto>
          <Divider />
          <div className='titleContainer'>
            <span>Descrição da parcela:</span>
            <span>Número da parcela:</span>
            <span>Contrato:</span>
            {/* <span>Valor ajustado:</span> */}
          </div>
          <Divider />
          <div className='content'>
            {arrayParcelas?.length > 0 &&
              arrayParcelas.map(({ parcela }, index) => {
                return (
                  <div key={parcela?.numeroParcelaGeral}>
                    <div className='row'>
                      <span className='numberRow'>{index + 1}</span>
                      <div className='parcela'>
                        <span>{parcela?.descricaoParcela}</span>

                        <span>{parcela?.numeroParcela}</span>

                        <span>
                          {functionsCardBoletos?.getNomeContrato(
                            parcela?.idVenda
                          )}
                        </span>
                        {/* <span>
                          {formatCurrent(parcela?.valorReajustado?.toFixed(2))}
                        </span> */}
                      </div>
                    </div>
                    <Divider />
                  </div>
                );
              })}
          </div>

          {!textoProcessando && (
            <ButtonsContainer>
              <div className='container-buttons-boleto'>
                <span className='info-text'>Opções do boleto:</span>
                <div>
                  <BotaoVisualizarBoleto
                    width={176}
                    tema={tema}
                    seuNumero={arrayParcelas[0]?.parcela?.seuNumero}
                    bancoBoleto={arrayParcelas[0]?.parcela?.bancoBoleto}
                    vencimentoBoleto={formatDate(
                      arrayParcelas[0]?.parcela?.dtVencBoleto
                    )}
                  />
                  <BotaoEnviarBoletoEmail
                    width={176}
                    light
                    seuNumero={arrayParcelas[0]?.parcela?.seuNumero}
                    bancoBoleto={arrayParcelas[0]?.parcela?.bancoBoleto}
                    tema={tema}
                  />

                  <BotaoCopiarCodBoleto
                    width={176}
                    light
                    seuNumero={arrayParcelas[0]?.parcela?.seuNumero}
                    bancoBoleto={arrayParcelas[0]?.parcela?.bancoBoleto}
                    tema={tema}
                  />
                </div>
              </div>
              {isShowPaymentMethods && (
                <div className='container-buttons-pagamento'>
                  <span className='info-text'>Outras formas de pagamento:</span>
                  <div>
                    {isShowCard && (
                      <BotaoCartao
                        width={176}
                        tema={tema}
                        light
                        parcelas={arrayParcelas}
                      />
                    )}

                    {isShowPix && (
                      <BotaoPix
                        width={176}
                        tema={tema}
                        parcelas={arrayParcelas}
                      />
                    )}
                  </div>
                </div>
              )}
            </ButtonsContainer>
          )}
          {processandoPix && (
            <ProcessìngPixButtonContainer>
              <BotaoPix
                width={176}
                tema={tema}
                parcelas={arrayParcelas}
                processandoPix
              />
            </ProcessìngPixButtonContainer>
          )}
        </BodyCardBoleto>
      </ContainerInfos>
    </ContainerCardBoletos>
  );
};

export default CardBoletos;
